import React, { useEffect, useMemo, useState } from "react";
import "./Paiement.css";

export default function Paiement() {
  const products = useMemo(
    () => [
      {
        id: 1,
        price: "$120",
        bg: "#F6E7B6",
        img: "/flooz.png",
        alt: "Yellow backpack",
      },
      {
        id: 2,
        price: "$220",
        bg: "#DCD6FF",
        img: "/visa.png",
        alt: "Red backpack",
      },
      {
        id: 3,
        price: "$320",
        bg: "#CFF5EA",
        img: "/yas.png",
        alt: "Dark backpack",
      },
      {
        id: 4,
        price: "$180",
        bg: "#FFD9C7",
        img: "/master.jpg",
        alt: "Backpack variant",
      },
    ],
    []
  );

  const [start, setStart] = useState(0);

  const visible = useMemo(() => {
    // 3 items visibles comme sur l'image
    const arr = [];
    for (let i = 0; i < 3; i++) {
      arr.push(products[(start + i) % products.length]);
    }
    return arr;
  }, [products, start]);

  const prev = () => setStart((s) => (s - 1 + products.length) % products.length);
  const next = () => setStart((s) => (s + 1) % products.length);

  // auto (léger) pour donner vie — tu peux enlever si tu veux
  useEffect(() => {
    const t = setInterval(() => setStart((s) => (s + 1) % products.length), 5200);
    return () => clearInterval(t);
  }, [products.length]);

  return (
    <section className="serviceWrap-stcd">
      <div className="serviceInner-stcd">
        <div className="serviceGrid-stcd">
          {/* LEFT */}
          <div className="left-stcd">
            <h2 className="title-stcd">
              Paiements <br />
              <span className="titleBold-stcd">en ligne.</span>
            </h2>

            <p className="desc-stcd">
             Encaissez des paiements en ligne en toute sécurité et proposez à vos clients un service de livraison fiable et sécurisé.
            </p>

            <div className="btnRow-stcd">
              
              <a className="btnGhost-stcd" href="https://wa.me/+22893410827" style={{textDecoration:'none'}}>
                <span className="playDot-stcd" aria-hidden="true" />
                Implementer un Paiement en ligne
              </a>
            </div>

            {/* Bottom-left mini carousel */}
            <div className="miniArea-stcd">
              <button className="miniNav-stcd miniPrev-stcd" onClick={prev} aria-label="Previous">
                «
              </button>

              <div className="miniRow-stcdT">
                {visible.map((p) => (
                  // <div key={p.id} className="miniCard-stcd" style={{ background: p.bg }}>
                    <img className="miniImg-stcdT" src={p.img} alt={p.alt} />
                  // </div>
                ))}
              </div>

              <button className="miniNav-stcd miniNext-stcd" onClick={next} aria-label="Next">
                »
              </button>
            </div>
          </div>

          {/* RIGHT */}
          <div className="right-stcd">
            <div className="heroWrap-stcd">
              {/* “petales” */}
              <div className="petals-stcd" aria-hidden="true">
                <span className="petal-stcd p1-stcd" />
                <span className="petal-stcd p2-stcd" />
                <span className="petal-stcd p3-stcd" />
                <span className="petal-stcd p4-stcd" />
                <span className="petal-stcd p5-stcd" />
              </div>

              {/* HERO IMAGE */}
              <img
                className="heroImg-stcd"
                src="/pt1.jpg"
                alt="Backpack"
              />
            </div>

            {/* Price + colors + rating block (bottom-right) */}
            <div className="meta-stcd">
          
              <div className="ratingRow-stcd">
                <div className="rating-stcd">
                  <span className="ratingBig-stcd">24h</span>
                  <span className="ratingSmall-stcd">/7</span>
                </div>
                <div className="ratingText-stcd">
                  FLOOZ <br /> / TMONEY , CARTE BANCAIRE ETC....
                </div>
              </div>

              <div className="reviewRow-stcd">
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
